import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
// <p style="text-align:right;margin-right:15px;">平成17年3月30日制定<br/>平成22年8月25日改訂</p> はscssファイルで定義します。※classNameはwordsというものです。

export const privacy = type => {
  document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜個人情報の取扱いについて';
  return (
    <div className="container">
      {breadcrumbs(type, [
        { text: "個人情報の取扱いについて" },
      ])}
      
      <div className="privacy">
        <h2 className="bold" id="contentsHead">個人情報の取扱いについて（プライバシーポリシー）</h2>
        <p className="basicTxt01">
          <p>
            　エリアリンク株式会社（以下「弊社」といいます。）は、弊社が行う各種サービスに関連し、その活動を行うために多くの個人情報を保有するものであるところ、お客様その他の関係者の個人情報の保護が重大な責務であることを認識し、個人情報の取扱いに関する方針を次のとおり定めます。
            <br />
            　なお、本文中の用語の定義は、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）及び関連法令によります。
          </p>
        </p>
        <div className="box02">
          <h3>１．関連法令・ガイドライン等の遵守</h3>
          <div className="box02Txt">
            <p>
              　弊社では、個人情報保護法その他の関連法令、個人情報保護委員会の定めるガイドライン等及び本プライバシーポリシーを遵守し、個人情報を適法かつ適正に取扱います。
            </p>
          </div>
        </div>
        <div className="box02">
          <h3>２．個人情報の取得</h3>
          <div className="box02Txt">
            <p>
              　弊社は、お客様その他の関係者の個人情報を、利用目的の達成に必要な範囲内で、適法かつ適正な手段により取得します。弊社が取得する個人情報とは、弊社がお客様その他の関係者からご提供いただく個人情報、当社が取得又は第三者から提供される個人情報をいいます。
            </p>
            <p>
              ※お客様等にご提供いただく個人情報としては、氏名、住所、電話番号、FAX番号、Eメールアドレス、送付先情報などが挙げられますが、ご利用いただくサービス又は個別取引の内容によっては、より詳しい個人情報をいただく場合があります。
            </p>
          </div>
        </div>
        <div className="box02">
          <h3>３．個人情報の利用目的</h3>
          <div className="box02Txt">
            <p>
              　弊社は、お客様その他の関係者の個人情報を、以下の業務並びに利用目的の範囲内又はその取得状況から明らかである利用目的の範囲内で利用します。
            </p>
            <ul className="privacyList">
              （業務）
              <li>ストレージ事業（レンタル収納スペース〔室内トランクタイプ、屋外コンテナタイプ、土地付きストレージタイプ〕・ガレージの運営及び管理に関する業務、工事の設計・施工・監理・請負に関する業務、コンテナ・トランクルームの製造・販売など）</li>
              <li>不動産販売・アセット事業（底地〔土地権利整備〕事業、駐車場事業、不動産の売買・賃貸・仲介・管理及びコンサルティングに関する業務、パーキング機械その他動産の販売・賃貸・管理に関する業務など）</li>
              <li>貸会議室事業（貸会議室に関する業務など）</li>
              <li>オフィス事業（レンタルオフィスに関する業務など）</li>
              <li>上記事業・業務に付帯又は関連する一切の業務</li>
              <li>一般管理業務（上記各事業の管理統括、企画、人事、総務、財務、経理、広報、法務、労務等の業務も含む）</li>
            </ul>
            <ul className="privacyList">
              （目的）
              <li>弊社事業における商品及びサービスに関する契約上の弊社の義務履行又は権利行使のため。</li>
              <li>弊社事業における商品及びサービスのご予約・お申込み・ご契約の業務（審査等の手続その他諸対応を含む）のため。</li>
              <li>弊社事業の商品・サービスの代金決済に関する業務のため（請求、返金、支払等及び関連する事務処理）。</li>
              <li>弊社事業における商品又はサービスの契約後の管理、アフターサービス、サポートのため。</li>
              <li>弊社施設及び弊社が管理する施設の保守・保全・修繕・緊急対応のため。</li>
              <li>お取引・契約管理及びお取引・契約に関するご連絡のため。</li>
              <li>弊社事業における商品・サービスの品質向上・企画・研究・開発のため。</li>
              <li>弊社が取り扱うその他の商品及びサービスのご案内、提供及び管理のため</li>
              ※お客様が弊社のその他の商品・サービスに関する情報配信を希望されない場合、その旨を弊社にご連絡頂ければ配信を停止することができます。
              <li>弊社事業に関する各種イベント、キャンペーン、応募懸賞のご案内、運営、管理及び各種情報の提供のため。</li>
              <li>弊社の商品・サービス等に関するアンケート・調査の実施、顧客層・顧客要望等分析その他マーケットリサーチのため。</li>
              <li>電子メール配信サービスや刊行物の発送のため。</li>
              <li>本人確認・信用調査のため。</li>
              <li>電話対応等の品質向上、トラブル防止、お問い合わせ、資料請求その他ご依頼等への対応のため。</li>
              ※お客様が当社へ個人情報を提供された後、弊社からお客様へ商品やサービスに関する情報をEメール等にてご提供させていただく場合があります。
              <li>弊社施設内及び弊社が管理する施設内の安全確保のため。</li>
              <li>株主管理及び株主様に対し会社法等に基づき適正なご連絡をし、また義務の履行等をするため。</li>
              <li>人事・労務、研修、その他の雇用管理、福利厚生、これらに付随する諸対応のため。</li>
              <li>採用活動に関連する諸対応のため。</li>
              <li>その他上記に付随、関連する業務の遂行のため。</li>
            </ul>
          </div>
        </div>
        <div className="box02">
          <h3>４．個人情報の管理</h3>
          <div className="box02Txt">
            <p>
              　弊社は、お客様その他の関係者からご提供いただいた個人情報の管理について、以下を徹底します。
            </p>
            <p>
              1). 個人データの正確性の確保
              <br />
              　お客様その他の関係者からご提供いただいた個人データについては、利用目的の達成に必要な範囲内において、正確かつ最新の内容に保つとともに、利用する必要がなくなったときは当該個人データを消去するよう努めます。
            </p>
            <p>
              2). 安全管理措置
              <br />
              　弊社は、個人データの漏えい、滅失又は毀損の防止その他の個人データの適切な管理のために別途社内規程の整備を行い、その遵守徹底を図るなど必要かつ適切な措置を講じます。
            </p>
            <p>
              3). 従業者の監督
              <br />
              　弊社は、個人情報を取扱う全ての役職員に対し、個人情報の適正な取扱いを周知徹底するとともに、適正な教育を行い、弊社の社内規程に基づき、必要かつ適切な監督を行います。
            </p>
            <p>
              4). 委託先の監督
              <br />
              　弊社は、お客様その他の関係者の個人データの取扱いを外部に委託する場合には、委託先には適切な安全管理措置を講じている協力会社を選定し、委託先に対し必要かつ適切な監督を行います。
            </p>
          </div>
        </div>
        <div className="box02">
          <h3>５．個人データの第三者提供について</h3>
          <div className="box02Txt">
            <p>
              　弊社は、上記２．に従って取得した個人情報について、個人情報保護法その他関連法令により認められる場合を除き、お客様その他の関係者ご本人の事前同意を得ずに第三者（委託先、合併その他の事由による事業承継先を除きます）に提供いたしません。
            </p>
          </div>
        </div>
        <div className="box02">
          <h3>６．個人データの委託</h3>
          <div className="box02Txt">
            <p>
              　弊社は、業務を円滑に進め、また、お客様に商品・サービスをご提供するにあたり、その業務の一部を委託し、利用目的の達成に必要な範囲内で、協力会社である業務委託先に対して個人データを提供することがあります。この場合、業務委託先との間で個人情報の取扱いに関する契約の締結をはじめ、適切に業務委託先の管理及び監督を行います。
            </p>
          </div>
        </div>
        <div className="box02">
          <h3>７. 保有個人データの開示等</h3>
          <div className="box02Txt">
            <p>
              １）弊社は、弊社の保有個人データについて、ご本人から所定の方法により、保有個人データの開示等（利用目的の通知、開示、訂正、追加、削除、利用停止、消去、第三者への提供停止）に関するご請求があった場合、ご本人であることを確認のうえで、法令及び弊社の社内規程に従い、合理的な期間及び範囲で対応いたします。開示等の具体的な請求方法については、個別にご案内しますので、下記受付窓口までお問い合わせください。
              <br />
              <br />
              ＜受付窓口＞
              <br />
              <a href="mailto:info@arealink.co.jp">info@arealink.co.jp</a>
            </p>
            <p>
              ２）手数料
              <br />
              　開示等のご依頼に対し、弊社所定の手数料がかかることがありますので、詳しくは上記受付窓口までお問合せください。
            </p>
          </div>
        </div>
        <div className="box02">
          <h3>８. プライバシーポリシーの改定</h3>
          <div className="box02Txt">
            <p>
              　弊社は、個人情報の取扱いについて改善を図るため、本プライバシーポリシーの内容を適宜見直し、必要に応じてその全部または一部を改訂することがあります。その場合、改定版の公表の日から改定後のプライバシーポリシーが適用されることになります。なお、重要な変更がある場合は、弊社ウェブサイトにおいてもお知らせします。
            </p>
          </div>
        </div>
        <div className="box02">
          <h3>９．個人情報の取扱いに関する相談や苦情の連絡先</h3>
          <div className="box02Txt">
            <p>
              　個人情報の取扱いに関するお問合せはこちらまでお問合せください。
              <br />
              <br />
              ＜相談窓口＞
              <br />
              <a href="mailto:info@arealink.co.jp">info@arealink.co.jp</a>
            </p>
          </div>
        </div>
        <p className="words">
          エリアリンク株式会社
          <br />
          制定日：2005年3月20日
          <br />
          改定日：2020年1月20日
        </p>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/static/privacy.jsx